/* eslint-disable @nx/enforce-module-boundaries */
import React, { useState, useEffect, useContext, useRef } from 'react';
import QuantityInputBox from 'v4/components/common/QuantityInput';
import { cardList, validatePromoCode } from 'v4/store/actions/payments.actions';
import { Input, InputGroup, InputRightElement } from '@mybridge/ui/input';
import { CloseIcon } from '@chakra-ui/icons';
import {
  VisaIcon,
  AmexIcon,
  CardIcon,
  MastercardIcon,
  CirclePlusBg,
} from '@mybridge/icons';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import {
  getJobSubscriptionDetails,
  getJobCheckout,
  jobSubscriptionPriceDetails,
  createJobSubscription,
  updateJobSubscription,
  purchasedJobSlots,
  setSubscriptionCompanyId,
  clearSubscriptionCompanyId,
  previewJobSubscription,
} from 'v4/store/actions/companyJobs.actions';
import Link from 'next/link';
import SectionLoader from 'v4/components/common/loader/sectionLoader';
import {
  Box,
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Container,
  Flex,
  HStack,
  Skeleton,
  Spacer,
  Text,
  IconButton,
} from '@mybridge/ui';
import styles from '../../../create/createCompany.module.scss';
import { useRouter } from 'next/router';
import { Radio } from '@mybridge/ui';
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  AlertDialogCloseButton,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  useToast,
} from '@chakra-ui/react';
import { useDisclosure } from '@chakra-ui/react';
import { AuthenticatedProviders } from 'v4/snippets/providers/authenticated';
import { isMobile } from 'react-device-detect';
import { CreateJobsContext } from 'v4/components/company/Layout/context';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useDirection } from '@mybridge/ui/custom-hooks/useDirection';
import { InfoLinedIcon } from '@mybridge/icons/CampaignIcon';
const JobSubscriptionPage = (props) => {
  const { selectedCompany } = props;
  const { t } = useTranslator();
  const direction = useDirection();
  const router = useRouter();
  const params = useRouter();
  const dispatch = useDispatch();
  const toast = useToast();
  const cardAlertDisc = useDisclosure();
  let baseSlotPrice = 0;
  let finalSlotPrice = 0;
  const { cardInfo } = useSelector((state) => state.payment);
  const {
    userJobSubscription,
    jobSubscriptionPlans,
    jobSubscriptionProcess,
    companyIdForSubscriptionRedirect,
    jobSubscriptionPreview,
    loading,
  } = useSelector((state) => state.companyJobs);
  const {
    jobDetails
  } = useContext(CreateJobsContext);
  const [checkoutStep, setCheckoutStep] = useState(1);
  const [slotQuantity, setSlotQuantity] = useState(() => {
    if (typeof window !== 'undefined') {
      const savedQuantity = localStorage.getItem('jobSlotQuantity');
      return savedQuantity ? parseInt(savedQuantity, 10) : 1;
    }
    return 1;
  });
  const [slotPrice, setSlotPrice] = useState(baseSlotPrice);
  const [finalPrice, setFinalPrice] = useState(baseSlotPrice);
  const [maxSlotAllowed, setMaxSlotAllowed] = useState(0);
  const [remainingSlots, setRemainingSlots] = useState(0);
  const [monthlyPlan, setMonthlyPlan] = useState(null);
  const [yearlyPlan, setYearlyPlan] = useState(null);
  const [planPricing, setPlanPricing] = useState([]);
  const [currentSubscription, setCurrentSubscription] = useState();
  const [jobBilledAs, setJobBilledAs] = useState('price_monthly');

  // const offerPayload = {
  //   hasOffer: true,
  //   offerTitle: 'Special Offer Discount',
  //   offerCode: 'OFFER25',
  //   discountAmount: 5.00,
  // };
  // const [isOfferApplied, setIsOfferApplied] = useState(false);
  const [showOfferInput, setShowOfferInput] = useState(false);
  const [offerCodeInput, setOfferCodeInput] = useState('');
  const [appliedOffer, setAppliedOffer] = useState(null);
  const [offerLoading, setOfferLoading] = useState(false);
  const [offerError, setOfferError] = useState('');

  const handleApplyOffer = async (customCode, customAmount) => {
    const codeToValidate = typeof customCode === 'string' ? customCode : offerCodeInput;
    if (!codeToValidate || !codeToValidate.trim()) return;
    setOfferLoading(true);
    setOfferError('');
    try {
      const amountToValidate = typeof customAmount === 'number' || typeof customAmount === 'string' ? customAmount : slotPrice;
      const res = await dispatch(
        validatePromoCode({
          code: codeToValidate.trim(),
          service_type: 'JOB',
          billed_type: jobBilledAs === 'price_monthly' ? 'monthly' : 'yearly',
          amount: (amountToValidate || 0).toString(),
        })
      );
      if (res?.payload?.valid) {
        setAppliedOffer(res.payload);
        setOfferError('');
      } else {
        setOfferError(res?.payload?.message || 'Invalid offer code');
      }
    } catch (err) {
      setOfferError('Failed to validate offer code');
    } finally {
      setOfferLoading(false);
    }
  };

  useEffect(() => {
    if (appliedOffer?.code && appliedOffer?.valid) {
      handleApplyOffer(appliedOffer.code, slotPrice);
    }
  }, [slotPrice]);

  const handleRemoveOffer = () => {
    setAppliedOffer(null);
    setOfferCodeInput('');
    setOfferError('');
  };

  useEffect(() => {
    setAppliedOffer(null);
    setOfferCodeInput('');
    setOfferError('');
    setShowOfferInput(false);
  }, [jobBilledAs]);
  const companyId = selectedCompany
    ? selectedCompany
    : params?.query?.id?.toString();
  const defaultCard = _.find(cardInfo?.cards, {
    id: cardInfo?.default_card_id,
  });
  useEffect(() => {
    dispatch(getJobSubscriptionDetails());
    dispatch(jobSubscriptionPriceDetails());
    dispatch(cardList());
    // eslint-disable-next-line
  }, []);

  // Clear stale localStorage values if not coming from job posting flow
  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (selectedCompany) {
        localStorage.removeItem('JobRedirect');
        localStorage.removeItem('SubscriptionCompanyId');
        localStorage.removeItem('recentSavedJob');
      }
    }
    // eslint-disable-next-line
  }, []);
  
  // useEffect(() => {
  //   if (jobSubscriptionProcess?.status) {
  //     window.location.assign(jobSubscriptionProcess?.URL);
  //   }
  // }, [jobSubscriptionProcess]);
  // const notificationRef = useRef(false);

  // useEffect(() => {
  //   console.log('jobSubscriptionProcess', jobSubscriptionProcess, notificationRef.current);
  //   if (jobSubscriptionProcess?.status === true && !notificationRef.current) {
  //     // Clear localStorage on subscription success
  //     if (typeof window !== 'undefined') {
  //       localStorage.removeItem('jobSlotQuantity');
  //     }
  //     // Show success toast instead of redirecting
  //     toast({
  //       title: 'Success',
  //       description: jobSubscriptionProcess?.message  || 'Your job subscription has been processed successfully.',
  //       status: 'success',
  //       duration: 5000,
  //       isClosable: true,
  //       position: 'top',
  //     });
  //     notificationRef.current = true
  //   }else if (jobSubscriptionProcess?.status >= 400) {
  //     // Clear localStorage on subscription failure
  //     if (typeof window !== 'undefined') {
  //       localStorage.removeItem('jobSlotQuantity');
  //     }
  //     toast({
  //       description: jobSubscriptionProcess?.error || 'Something went wrong.',
  //       status: 'error',
  //       duration: 5000,
  //       isClosable: true,
  //       position: 'top',
  //     });
  //   }
  // }, [jobSubscriptionProcess]);

  useEffect(() => {
    if (jobSubscriptionPlans) {
      setMonthlyPlan(
        jobSubscriptionPlans?.[0]?.interval === 'month'
          ? jobSubscriptionPlans?.[0]
          : jobSubscriptionPlans?.[1]
      );
      setYearlyPlan(
        jobSubscriptionPlans?.[0]?.interval === 'year'
          ? jobSubscriptionPlans?.[0]
          : jobSubscriptionPlans?.[1]
      );
      setPlanPricing(jobSubscriptionPlans?.[2]);
    }
  }, [jobSubscriptionPlans]);

  // Update slotQuantity from jobSubscriptionPreview if available
  // Only use backend value if localStorage doesn't have a value
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const savedQuantity = localStorage.getItem('jobSlotQuantity');
      // Only use backend value if localStorage doesn't have a value
      if (!savedQuantity && jobSubscriptionPreview?.quantity && jobSubscriptionPreview.quantity > 0) {
        setSlotQuantity(jobSubscriptionPreview.quantity);
        localStorage.setItem('jobSlotQuantity', jobSubscriptionPreview.quantity.toString());
      }
    }
    // eslint-disable-next-line
  }, [jobSubscriptionPreview]);

  useEffect(() => {
    if (userJobSubscription?.results) {
      const jobSlotsDetails = _.find(
        userJobSubscription?.results,
        function (o) {
          if (companyId) {
            return o.company_page == companyId;
          } else {
            return o.subscription_type === 'I';
          }
        }
      );
      setCurrentSubscription(jobSlotsDetails);
      setMaxSlotAllowed(
        jobSlotsDetails?.job_slots ? jobSlotsDetails?.job_slots.total : 0
      );

      // setRemainingSlots(
      //   jobSlotsDetails?.job_slots
      //     ? jobSlotsDetails?.job_slots.remaining === -1
      //       ? 0
      //       : jobSlotsDetails?.job_slots.remaining
      //     : 0
      // );
      
      // Handle negative or -1 remaining slots
      const remaining = jobSlotsDetails?.job_slots?.remaining ?? 0;
      setRemainingSlots(remaining <= 0 ? 0 : remaining);

      // Update slotQuantity - prioritize localStorage, only use backend if localStorage is not available
      if (typeof window !== 'undefined') {
        const savedQuantity = localStorage.getItem('jobSlotQuantity');
        if (savedQuantity) {
          // Use localStorage value if available
          setSlotQuantity(parseInt(savedQuantity, 10));
        } else {
          // Only use backend value if localStorage doesn't have a value
          const backendQuantity = jobSlotsDetails?.quantity || jobSlotsDetails?.job_slots?.total;
          if (backendQuantity && backendQuantity > 0) {
            setSlotQuantity(backendQuantity);
            localStorage.setItem('jobSlotQuantity', backendQuantity.toString());
          }
        }
      }
    }
    // eslint-disable-next-line
  }, [userJobSubscription]);
  const displayCardIcon = (brand) => {
    switch (brand) {
      case 'visa':
        return <VisaIcon />;
      case 'mastercard':
        return <MastercardIcon />;
      case 'amex':
        return <AmexIcon />;
      default:
        return <CardIcon />;
    }
  };
  const handlePaymentSubmit = async (selectedPlan) => {
    if (!cardInfo.default_card_id) {
      cardAlertDisc.onOpen();
      return;
    }
    
    if (companyIdForSubscriptionRedirect) {
      dispatch(clearSubscriptionCompanyId());
    }
    if (typeof window !== 'undefined') {
      // Perform localStorage action
      localStorage.removeItem('subscriptionCompId');
    }
    let payload = {};
    if (!currentSubscription?.subscription_id) {
      if (jobDetails?.id && typeof window !== 'undefined') {
        try {
          localStorage.setItem('recentSavedJob', JSON.stringify(jobDetails));
        } catch (e) {
          console.log('Error saving job details to localStorage', e);
        }
      }
      
      payload = {
        price_id:
          jobBilledAs === 'price_monthly'
            ? monthlyPlan?.price_id
            : yearlyPlan?.price_id,
        quantity: slotQuantity,
        company_page: companyId,
        subscription_type: selectedCompany || params?.query?.id ? 'C' : 'I',
        interval: jobBilledAs === 'price_monthly' ? 'monthly' : 'yearly',
        ...(appliedOffer?.valid && appliedOffer?.code ? { promo_code: appliedOffer.code } : {}),
      };
      dispatch(createJobSubscription(payload)).then((res) => {
        if (res?.error || (res?.payload && res?.payload?.message?.includes('cannot'))) {
          // Clear localStorage on subscription failure
          if (typeof window !== 'undefined') {
            localStorage.removeItem('jobSlotQuantity');
          }
          toast({
            title: 'Error',
            description: res?.payload?.message || res?.error?.message || 'Failed to create subscription',
            status: 'error',
            duration: 5000,
            isClosable: true,
            position: 'top',
          });
          return;
        }
        
        const isSuccess = res?.payload?.status === true;
        
        if (isSuccess) {
          // Clear localStorage on subscription success
          if (typeof window !== 'undefined') {
            localStorage.removeItem('jobSlotQuantity');
          }
          let jobId = jobDetails?.id;
          
          if (!jobId && typeof window !== 'undefined') {
            try {
              const storedJobDetails = localStorage.getItem('recentSavedJob');
              if (storedJobDetails) {
                const parsedJobDetails = JSON.parse(storedJobDetails);
                jobId = parsedJobDetails?.id;
              }
            } catch (e) {
              console.log('Error parsing stored job details', e);
            }
          }
          
          if (jobId) {
            router.push(`/page/jobs/edit/${jobId}`);
          } else {
            toast({
              title: 'Success',
              description: res?.payload?.message || 'Your job subscription has been created successfully.',
              status: 'success',
              duration: 5000,
              isClosable: true,
              position: 'top',
            });
            
            setTimeout(() => {
              if(props?.selectedCompany && props?.fromSettings){
                router.push(`/page/private/${props?.selectedCompany}/jobs`);
              }else{
                router.push('/jobs/suggested');
              }
            }, 2000);
          }
        }
      });
      dispatch(purchasedJobSlots(slotQuantity));
    } else {
      if (jobDetails?.id && typeof window !== 'undefined') {
        try {
          localStorage.setItem('recentSavedJob', JSON.stringify(jobDetails));
        } catch (e) {
          console.log('Error saving job details to localStorage', e);
        }
      }
      
      payload = {
        price_id:
          jobBilledAs === 'price_monthly'
            ? monthlyPlan?.price_id
            : yearlyPlan?.price_id,
        quantity: slotQuantity,
        company_page: companyId,
        subscription_id: currentSubscription.subscription_id,
        subscription_type: selectedCompany || params?.query?.id ? 'C' : 'I',
        interval: jobBilledAs === 'price_monthly' ? 'monthly' : 'yearly',
        ...(appliedOffer?.valid && appliedOffer?.code ? { promo_code: appliedOffer.code } : {}),
      };
      // dispatch(updateJobSubscription(payload));
      // setCheckoutStep(1);
      // if(jobDetails?.id){

      //   router.push(`/page/jobs/edit/${jobDetails?.id}`)
      // }
      dispatch(updateJobSubscription(payload)).then((res) => {
        if (res?.error || (res?.payload && res?.payload?.message?.includes('cannot'))) {
          // Clear localStorage on subscription failure
          if (typeof window !== 'undefined') {
            localStorage.removeItem('jobSlotQuantity');
          }
          toast({
            title: 'Error',
            description: res?.payload?.message || res?.error?.message || 'Failed to update subscription',
            status: 'error',
            duration: 5000,
            isClosable: true,
            position: 'top',
          });
          setCheckoutStep(1);
          return;
        } 
        
        const isSuccess = res?.payload?.status === true;
        
        if (isSuccess) {
          // Clear localStorage on subscription success
          if (typeof window !== 'undefined') {
            localStorage.removeItem('jobSlotQuantity');
          }
          let jobId = jobDetails?.id;
          
          if (!jobId && typeof window !== 'undefined') {
            try {
              const storedJobDetails = localStorage.getItem('recentSavedJob');
              if (storedJobDetails) {
                const parsedJobDetails = JSON.parse(storedJobDetails);
                jobId = parsedJobDetails?.id;
              }
            } catch (e) {
              console.log('Error parsing stored job details', e);
            }
          }
          
          if (jobId) {
            router.push(`/page/jobs/edit/${jobId}`);
          } else {
            toast({
              title: 'Success',
              description: res?.payload?.message || 'Your job subscription has been updated successfully.',
              status: 'success',
              duration: 5000,
              isClosable: true,
              position: 'top',
            });
            
            setTimeout(() => {
              if(props?.selectedCompany && props?.fromSettings){
                router.push(`/page/private/${props?.selectedCompany}/jobs`);
              }else{
                router.push('/jobs/suggested');
              }
            }, 2000);
          }
        }
      });
      dispatch(purchasedJobSlots(slotQuantity));
    }
    // const body = {
    //   price_id: jobBilledAs === 'price_monthly' ? jobSubscriptionPlans?.[1]?.price_id : jobSubscriptionPlans?.[0]?.price_id,
    //   quantity: slotQuantity,
    //   company_page: companyId,
    //   subscription_id: currentSubscription?.subscription_id,
    // };
    // dispatch(updateJobSubscription(body));
  };
  const createNewSubscription = () => {
    let payload = {};
    if (!currentSubscription?.subscription_id) {
      const calculatedFinal = appliedOffer?.valid
        ? (appliedOffer.final_amount != null ? appliedOffer.final_amount : Math.max(0, slotPrice - (appliedOffer.discount_amount || 0)))
        : slotPrice;
      setFinalPrice(calculatedFinal);
      setCheckoutStep(2);
    } else {
      payload = {
        price_id:
          jobBilledAs === 'price_monthly'
            ? monthlyPlan?.price_id
            : yearlyPlan?.price_id,
        quantity: slotQuantity,
        company_page: companyId,
        subscription_id: currentSubscription.subscription_id,
        subscription_type: selectedCompany || params?.query?.id ? 'C' : 'I',
        ...(appliedOffer?.valid && appliedOffer?.code ? { promo_code: appliedOffer.code } : {}),
      };
      dispatch(previewJobSubscription(payload)).then((res) => {
        if(res?.payload?.due_amount){
          setFinalPrice(res?.payload?.due_amount);
        }
      });
      setCheckoutStep(2);
    }
  };
  // const ButtonContainer = (props) => {
  const renderButtonContainer = (currentStep) => {
    if (currentStep === 1) {
      return (
        <HStack justifyContent="flex-end" w="100%">
          {/* <Link href="company/jobs/create"> */}
            <Button variant="secondary" borderRadius="50px" me={3} onClick={() => {
              const { id } = router.query;
              if(props?.setSelectedCompany){
                props?.setSelectedCompany(null)
              }else{
                if(typeof window !== 'undefined'){
                  localStorage.removeItem('jobSlotQuantity')
                  localStorage.removeItem('recentSavedJob')
                  router.push(`/page/private/${id[0]}`) 
                }
              }
            }}>
            {t('buttons.cancel') || "Cancel"}
          </Button>
          <Button
            variant="primary"
            borderRadius="50px"
            onClick={() => {
              createNewSubscription();
              // setCheckoutStep(2);
            }}
          >
            {t('settingsSubscription.reviewOrder') || "Review Order"}
          </Button>
        </HStack>
      );
    } else if (currentStep === 2) {
      return (
        <HStack justifyContent="flex-end" w="100%">
          <Button borderRadius={"30px"} variant="secondary" me={3} onClick={() => setCheckoutStep(1)}>
            {t('buttons.back') || "Back"}
          </Button>
          <Button
            borderRadius={"30px"}
            variant="primary"
            onClick={() => handlePaymentSubmit()}
            isDisabled={defaultCard ? false : true}
          >
            {t('myDisk.submit') || "Submit"}
          </Button>
        </HStack>
      );
    } else if (currentStep === 3) {
      return (
        <Flex className="d-flex justify-content-between w-100">
          <Box className="footer-left">
            <Button
              variant="secondary"
              me={3}
              onClick={() => setCheckoutStep(2)}
            >
              {t('buttons.back') || "Back"}
            </Button>
          </Box>
          <Spacer />
          <Box className="footer-right">
            <Link href="/page/jobs/create">
              <Button variant="secondary" me={3}>
                {t('buttons.cancel') || "Cancel"}
              </Button>
            </Link>
            <Button variant="primary" onClick={() => handlePaymentSubmit()}>
              {t('myDisk.submit') || "Submit"}
            </Button>
          </Box>
        </Flex>
      );
    }
  };

  const calculateTotalPrice = (quantity, period = 'month') => {
    let total = 0;
    for (const tier of planPricing) {
      if (quantity > tier.upto) {
        total += (tier.upto - tier.from + 1) * tier[`${period}_amount`];
      } else if (quantity >= tier.from && quantity <= tier.upto) {
        total += (quantity - tier.from + 1) * tier[`${period}_amount`];
        break;
      }
    }
    return total;
  };

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    baseSlotPrice = calculateTotalPrice(
      slotQuantity,
      jobBilledAs === 'price_monthly' ? 'month' : 'year'
    );
    setSlotPrice(baseSlotPrice);

    // if (slotQuantity >= 4 && slotQuantity <= 10) {
    //   // eslint-disable-next-line react-hooks/exhaustive-deps
    //   finalSlotPrice =
    //     (jobBilledAs === 'price_monthly' ? 50 : 35) * (slotQuantity - 3);
    // } else if (slotQuantity > 10) {
    //   finalSlotPrice =
    //     (jobBilledAs === 'price_monthly' ? 24 : 17) * (slotQuantity - 3);
    // } else {
    //   finalSlotPrice = 0;
    // }
    // setFinalPrice(finalSlotPrice);
    // }, [slotQuantity]);
  }, [slotQuantity, planPricing, jobBilledAs]);

  // Save slotQuantity to localStorage whenever it changes
  useEffect(() => {
    if (typeof window !== 'undefined') {
      localStorage.setItem('jobSlotQuantity', slotQuantity.toString());
    }
  }, [slotQuantity]);

  // const handleSlotUpdate = (e) => {
  //   setSlotQuantity(e);
  //   console.log(e);
  // }

  const handleJobBilledAs = (e) => {
    setJobBilledAs(e.target.value);
  };

  const handlePaymentSettings = () => {
    dispatch(setSubscriptionCompanyId(companyId));
    if (typeof window !== 'undefined') {
      // Perform localStorage action
      localStorage.setItem('subscriptionCompId', companyId);
    }
    router.push('/settings/billing-and-payment');
  };

  const isFromSettings = props?.fromSettings || router?.asPath?.includes('/settings') || router?.pathname?.includes('/settings');

  const renderMainSubscription = () => {
    return (
      <>
        {!isFromSettings && (
          <Box
            bg="#EBF8FF"
            border="1px solid"
            borderColor="#3d5a8071"
            color="#3d5a80"
            borderRadius="8px"
            p={3}
            mb={4}
          >
            <Text fontWeight="semibold" fontSize="sm">
              <Flex alignItems="center" gap={2}>
                <InfoLinedIcon width="18px" height="18px" />
                {"Your job has been saved as a draft"}
              </Flex>
            </Text>
            <Text fontSize="sm" color="#4A5568" mt={1}>
              {"Your job posting is safely saved in your drafts. Choose your subscription slots to publish it now, or publish it later from the Jobs page."}
            </Text>
          </Box>
        )}
        <Radio
          value="price_monthly"
          onChange={handleJobBilledAs}
          name="billed_as"
          size="lg"
          me="20px"
          isChecked={jobBilledAs === 'price_monthly'}
        >
          {t('settingsSubscription.billedMonthly') || "Billed monthly"}
        </Radio>
        <Radio
          value="price_yearly"
          onChange={handleJobBilledAs}
          name="billed_as"
          size="lg"
          isChecked={jobBilledAs === 'price_yearly'}
        >
          {t('settingsSubscription.billedYearly') || "Billed yearly"}
        </Radio>
        <Card my="30px" bgColor="brandGray.500" borderRadius="10px">
          <CardBody
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            textAlign="center"
            color="brandGray.700"
            py="10px"
            fontSize={['sm', 'md']}
          >
            <Text>
              {t('settingsSubscription.currentSubscription') || "Your myBridge subscription currently has"}
            </Text>
            <Text fontWeight="semibold" mt={1}>
              {remainingSlots} {remainingSlots === 1 ? 'remaining slot' : 'remaining slots'} {t('settingsSubscription.outOf') || "out of"} {maxSlotAllowed} {maxSlotAllowed === 1 ? 'total slot' : 'total slots'}
            </Text>
            {currentSubscription?.job_slots?.remaining < 0 && (
              <Text color="red.500" fontSize="sm" mt={2}>
                ⚠️ You have exceeded your limit by {Math.abs(currentSubscription.job_slots.remaining)} {Math.abs(currentSubscription.job_slots.remaining) === 1 ? 'slot' : 'slots'}. Please purchase more slots.
              </Text>
            )}
          </CardBody>
        </Card>
        <Box>
          <Table  className={styles.pricingTableCart}
           sx={{
            borderCollapse: 'separate',
            borderSpacing: 0,
            borderRadius: '20px',
            border: '1px solid',
            borderColor: 'brandGray.500',
            'tr td': {
             borderBottom: 'none'
             },
            'tr td:first-of-type': {
              // borderLeft: 'none',
              borderLeft: direction === 'rtl' ? 'auto' : 'none',
              borderRight: direction === 'rtl' ? 'none' : 'auto',
            },
            'tr td:last-of-type': {
              // borderRight: 'none',
              borderRight: direction === 'rtl' ? 'auto' : 'none',
              borderLeft: direction === 'rtl' ? 'none' : 'auto',
            },
            'tr:first-of-type th:first-of-type': {
              // borderTopLeftRadius: '20px',
              // borderLeft: 'none'
              borderTopLeftRadius: direction === 'rtl' ? '0' : '20px',
              borderTopRightRadius: direction === 'rtl' ? '20px' : '0',
              borderLeft: direction === 'rtl' ? 'auto' : 'none',
              borderRight: direction === 'rtl' ? 'none' : 'auto',
            },
            'tr:first-of-type th:last-of-type': {
              // borderTopRightRadius: '20px',
              // borderRight: 'none'
              borderTopRightRadius: direction === 'rtl' ? '0' : '20px',
              borderTopLeftRadius: direction === 'rtl' ? '20px' : '0',
              borderRight: direction === 'rtl' ? 'auto' : 'none',
              borderLeft: direction === 'rtl' ? 'none' : 'auto',
            },
            'tr:last-of-type td:first-of-type': {
              // borderBottomLeftRadius: '20px',
              // borderLeft: 'none'
              borderBottomLeftRadius: direction === 'rtl' ? '0' : '20px',
              borderBottomRightRadius: direction === 'rtl' ? '20px' : '0',
              borderLeft: direction === 'rtl' ? 'auto' : 'none',
              borderRight: direction === 'rtl' ? 'none' : 'auto',
            },
            'tr:last-of-type td:last-of-type': {
              // borderBottomRightRadius: '20px',
              // borderRight: 'none'
              borderBottomRightRadius: direction === 'rtl' ? '0' : '20px',
              borderBottomLeftRadius: direction === 'rtl' ? '20px' : '0',
              borderRight: direction === 'rtl' ? 'auto' : 'none',
              borderLeft: direction === 'rtl' ? 'none' : 'auto',
            },
          }}>
            <Thead>
              <Tr>
                <Th textTransform="none" p={['10px', '7px 0']}>
                  {isMobile ? t('settingsSubscription.jobSlots') || 'Job Slots' : t('settingsSubscription.numberOfJobSlots') || 'Number of Jobs slots'}
                </Th>
                <Th textTransform="none" p={['10px', '7px 0']}>
                  {t('settingsSubscription.jobSlotPriceMonthly') || "Price of job slots monthly"}
                </Th>
                <Th textTransform="none" p={['10px', '7px 0']}>
                  {t('settingsSubscription.jobSlotPriceYearly') || "Price of job slots yearly"}
                </Th>
              </Tr>
            </Thead>
            <Tbody>
              {loading ? (
                <>
                  <Tr>
                    <Td>{t('settingsSubscription.jobSlots1to3') || "1-3 job slots"}</Td>
                    <Td
                      className={
                        jobBilledAs === 'price_monthly'
                          ? styles.selected
                          : styles.monthly
                      }
                    >
                      <Skeleton
                        h="20px"
                        w="60px"
                        m="0 auto"
                        borderRadius="full"
                      />
                    </Td>
                    <Td
                      className={
                        jobBilledAs === 'price_yearly'
                          ? styles.selected
                          : styles.monthly
                      }
                    >
                      <Skeleton
                        h="20px"
                        w="60px"
                        m="0 auto"
                        borderRadius="full"
                      />
                    </Td>
                  </Tr>
                  <Tr>
                    <Td>{t('settingsSubscription.jobSlots4to10') || "4-10 job slots"}</Td>
                    <Td
                      className={
                        jobBilledAs === 'price_monthly'
                          ? styles.selected
                          : styles.monthly
                      }
                    >
                      <Skeleton
                        h="20px"
                        w="60px"
                        m="0 auto"
                        borderRadius="full"
                      />
                    </Td>
                    <Td
                      className={
                        jobBilledAs === 'price_yearly'
                          ? styles.selected
                          : styles.monthly
                      }
                    >
                      <Skeleton
                        h="20px"
                        w="60px"
                        m="0 auto"
                        borderRadius="full"
                      />
                    </Td>
                  </Tr>
                  <Tr>
                    <Td>{t('settingsSubscription.jobSlots11Plus') || "11+ job slots"}</Td>
                    <Td
                      className={
                        jobBilledAs === 'price_monthly'
                          ? styles.selected
                          : styles.monthly
                      }
                    >
                      <Skeleton
                        h="20px"
                        w="60px"
                        m="0 auto"
                        borderRadius="full"
                      />
                    </Td>
                    <Td
                      className={
                        jobBilledAs === 'price_yearly'
                          ? styles.selected
                          : styles.monthly
                      }
                    >
                      <Skeleton
                        h="20px"
                        w="60px"
                        m="0 auto"
                        borderRadius="full"
                      />
                    </Td>
                  </Tr>
                </>
              ) : (
                planPricing?.map((tier, i) => (
                  <Tr key={i}>
                    <Td>{tier?.text}</Td>
                    <Td
                      className={
                        jobBilledAs === 'price_monthly'
                          ? styles.selected
                          : styles.monthly
                      }
                    >
                      ${tier?.month_amount}
                    </Td>
                    <Td
                      className={
                        jobBilledAs === 'price_yearly'
                          ? styles.selected
                          : styles.monthly
                      }
                    >
                      ${tier?.year_amount}
                    </Td>
                  </Tr>
                ))
              )}
            </Tbody>
          </Table>
          {checkoutStep === 1 && (
            <>
              <Flex py={5} align="center">
                <Box color="#5B5B5B" fontSize="16px">
                  {t('settingsSubscription.jobSlotsToBuy') || "Job slots to buy"}
                </Box>
                <Spacer />
                <Box>
                  <QuantityInputBox
                    min={0}
                    max={100}
                    defaultValue={slotQuantity}
                    quantity={(value) => {
                      setSlotQuantity(value);
                      if (typeof window !== 'undefined') {
                        localStorage.setItem('jobSlotQuantity', value.toString());
                      }
                    }}
                  />
                </Box>
              </Flex>
              <hr />
              <Flex py={5} align="center">
                <Box fontSize="md" fontWeight="semibold">
                  {t('settingsSubscription.monthlySubscription') || "Monthly Subscription"}
                </Box>
                <Spacer />
                <Box fontWeight="semibold" fontSize="md">
                  ${slotPrice} {t('settingsSubscription.perMonth') || "per month"}
                </Box>
              </Flex>
              {appliedOffer?.valid ? (
                <>
                  <Flex justifyContent="space-between" alignItems="center" pb={3}>
                    <HStack spacing={2}>
                      <Text fontSize="sm" color="green.600" fontWeight="medium">
                        {appliedOffer.name || appliedOffer.code} ({appliedOffer.code})
                      </Text>
                      <Box
                        as="button"
                        fontSize="sm"
                        color="gray.400"
                        _hover={{ color: 'red.500', textDecoration: 'underline' }}
                        onClick={handleRemoveOffer}
                      >
                        Remove
                      </Box>
                    </HStack>
                    <Text fontSize="sm" fontWeight="bold" color="green.600">
                      -${(appliedOffer.discount_amount || 0).toFixed(2)}
                    </Text>
                  </Flex>
                  <Flex justifyContent="space-between" alignItems="center" pb={4} pt={2} borderTop="1px dashed" borderColor="gray.200">
                    <Text fontSize="md" fontWeight="bold" color="#333333">
                      {"Total Amount"}
                    </Text>
                    <Text fontSize="md" fontWeight="bold" color="green.600">
                      ${appliedOffer.final_amount != null ? Number(appliedOffer.final_amount).toFixed(2) : Math.max(0, slotPrice - (appliedOffer.discount_amount || 0)).toFixed(2)} {jobBilledAs === 'price_monthly' ? "per month" : "per year"}
                    </Text>
                  </Flex>
                </>
              ) : !showOfferInput ? (
                <Box pb={4}>
                  <Box
                    as="button"
                    fontSize="sm"
                    color="green.600"
                    fontWeight="semibold"
                    _hover={{ textDecoration: 'underline' }}
                    onClick={() => setShowOfferInput(true)}
                  >
                    Apply Promo Code
                  </Box>
                </Box>
              ) : (
                <Box pb={4}>
                  <InputGroup size="sm">
                    <Input
                      placeholder="Enter offer code"
                      value={offerCodeInput}
                      onChange={(e) => setOfferCodeInput(e.target.value)}
                      borderRadius="8px"
                      fontWeight={offerCodeInput ? "semibold" : "normal"}
                      pr="75px"
                    />
                    <InputRightElement width="70px" pr="4px">
                      {offerCodeInput?.length ? (
                        <Button
                          size="sm"
                          color="#3D5A80"
                          fontWeight="semibold"
                          variant="transparent"
                          isLoading={offerLoading}
                          onClick={handleApplyOffer}
                        >
                          Apply
                        </Button>
                      ) : (
                        <IconButton
                          size="xs"
                          variant="transparent"
                          icon={<CloseIcon width="10px" height="10px" color="gray.500" />}
                          onClick={() => {
                            setShowOfferInput(false);
                            setOfferCodeInput('');
                            setOfferError('');
                          }}
                        />
                      )}
                    </InputRightElement>
                  </InputGroup>
                  {offerError && (
                    <Text color="red.500" fontSize="xs" mt={1}>
                      {offerError}
                    </Text>
                  )}
                </Box>
              )}
            </>
          )}
          {checkoutStep === 2 && (
            <>
              <Flex py={5} align="center">
                <Box fontSize="16px" color="#5B5B5B">
                  {t('settingsSubscription.jobSlotsToBuy') || "Job slots to buy"}
                </Box>
                <Spacer />
                <Box
                  py={2}
                  px={3}
                  bg="#E4E6EB"
                  fontSize="md"
                  borderRadius="5px"
                >
                  {slotQuantity}
                </Box>
              </Flex>
              <hr />
              <Flex pt={5} align="center">
                <Box fontSize="md" fontWeight="semibold">
                  {t('settingsSubscription.monthlySubscription') || "Monthly Subscription"}
                </Box>
                <Spacer />
                <Box fontWeight="semibold" fontSize="md">
                  ${slotPrice} {t('settingsSubscription.per') || "per"}{' '}
                  {jobBilledAs === 'price_monthly' ? t('settingsSubscription.month') || 'month' : t('settingsSubscription.year') || 'year'}
                </Box>
              </Flex>
              {appliedOffer?.valid ? (
                <Flex py={2} align="center">
                  <HStack spacing={2}>
                    <Text fontSize="sm" color="green.600" fontWeight="medium">
                      {appliedOffer.name || appliedOffer.code} ({appliedOffer.code})
                    </Text>
                    <Box
                      as="button"
                      fontSize="xs"
                      color="gray.400"
                      _hover={{ color: 'red.500', textDecoration: 'underline' }}
                      onClick={handleRemoveOffer}
                    >
                      Remove
                    </Box>
                  </HStack>
                  <Spacer />
                  <Text fontSize="sm" fontWeight="bold" color="green.600">
                    -${(appliedOffer.discount_amount || 0).toFixed(2)}
                  </Text>
                </Flex>
              ) : !showOfferInput ? (
                <Box py={2}>
                  <Box
                    as="button"
                    fontSize="sm"
                    color="green.600"
                    fontWeight="semibold"
                    _hover={{ textDecoration: 'underline' }}
                    onClick={() => setShowOfferInput(true)}
                  >
                    Apply Promo Code
                  </Box>
                </Box>
              ) : (
                <Box py={2}>
                  <InputGroup size="sm">
                    <Input
                      placeholder="Enter offer code"
                      value={offerCodeInput}
                      onChange={(e) => setOfferCodeInput(e.target.value)}
                      borderRadius="8px"
                      pr="75px"
                    />
                    <InputRightElement width="70px" pr="4px">
                      {offerCodeInput?.length ? (
                        <Button
                          size="xs"
                          variant="transparent"
                          isLoading={offerLoading}
                          onClick={handleApplyOffer}
                        >
                          Apply
                        </Button>
                      ) : (
                        <IconButton
                          size="xs"
                          variant="transparent"
                          icon={<CloseIcon width="10px" height="10px" color="gray.500" />}
                          onClick={() => {
                            setShowOfferInput(false);
                            setOfferCodeInput('');
                            setOfferError('');
                          }}
                        />
                      )}
                    </InputRightElement>
                  </InputGroup>
                  {offerError && (
                    <Text color="red.500" fontSize="xs" mt={1}>
                      {offerError}
                    </Text>
                  )}
                </Box>
              )}
              <Flex pt={3} pb={5} align="center" borderTop="1px dashed #E4E6EB">
                <Box fontSize="md" fontWeight="semibold">
                  {t('settingsSubscription.dueToday') || "Due Today"}
                </Box>
                <Spacer />
                <Box fontWeight="semibold" fontSize="md">
                  ${(appliedOffer?.valid ? (appliedOffer.final_amount != null ? Number(appliedOffer.final_amount).toFixed(2) : Math.max(0, parseFloat(finalPrice || slotPrice) - (appliedOffer.discount_amount || 0)).toFixed(2)) : (finalPrice || slotPrice))} {t('settingsSubscription.per') || "per"}{' '}
                  {jobBilledAs === 'price_monthly' ? t('settingsSubscription.month') || 'month' : t('settingsSubscription.year') || 'year'}
                </Box>
              </Flex>
              <hr />
              <Flex
                justifyContent="space-between"
                alignItems="center"
                py={4}
                my={3}
              >
                {defaultCard ? (
                  <>
                    <Box flex="1">
                      <Button
                        p="0"
                        onClick={() => handlePaymentSettings()}
                        variant="transparent"
                        fontSize={['sm', 'md']}
                      >
                        {t('settingsSubscription.changeCard') || "Change Card"}
                      </Button>
                    </Box>
                    <HStack fontSize="md" fontWeight="semibold" flex="1">
                      {displayCardIcon(defaultCard?.card?.brand)}
                      <Box
                        as="span"
                        className="ms-2"
                        fontSize={['sm', 'md']}
                      >{`${t('settingsSubscription.cardEndingIn') || "Card ending in"} ${defaultCard?.card?.last4}`}</Box>
                    </HStack>
                    <Box
                      flex="1"
                      textAlign="right"
                      fontSize={['sm', 'md']}
                    >{`${defaultCard?.card?.exp_month}/${defaultCard?.card?.exp_year}`}</Box>
                  </>
                ) : (
                  <Link href="/settings/billing-and-payment">
                    <HStack  
                      onClick={(e) => {
                        e.preventDefault();
                        if (typeof window !== 'undefined') {
                          if (!selectedCompany) {
                            localStorage.setItem('JobRedirect', 'true');
                            localStorage.setItem('SubscriptionCompanyId', companyId);
                          }
                        }
                        router.push({
                          pathname: '/settings/billing-and-payment',
                          query:  props?.fromSettings ? {addingJob: false} : {addingJob: true} 
                          //fromSettings is undefined when we reach subscription page by adding job
                        });
                      }} 
                    >
                      <Text fontSize={['sm', 'md']} color="#333333">
                        {t('settingsSubscription.addNewCard') || "To continue, add New Credit or Debit card"}
                      </Text>{' '}
                      <CirclePlusBg />
                    </HStack>
                  </Link>
                )}
              </Flex>
            </>
          )}

          {checkoutStep === 3 && (
            <>
              <Flex py={5} align="center">
                <Box fontSize="md" fontWeight="semibold">
                  {t('settingsSubscription.jobSlotsToBuy') || "Job slots to buy"}
                </Box>
                <Spacer />
                <Box
                  py={2}
                  px={3}
                  bg="#E4E6EB"
                  fontWeight="semibold"
                  fontSize="md"
                  borderRadius="5px"
                  w="30px"
                >
                  {slotQuantity}
                </Box>
              </Flex>
              <hr className="my-4" />
              {jobSubscriptionProcess?.due_amount ? (
                <Flex py={5} align="center">
                  <Box fontSize="md" fontWeight="semibold">
                    {t('settingsSubscription.total') || "Total"}
                  </Box>
                  <Spacer />
                  <Box fontWeight="semibold" fontSize="md">
                    $
                    {jobSubscriptionProcess?.due_amount
                      ? jobSubscriptionProcess?.due_amount + slotPrice
                      : slotPrice}{' '}
                    {t('settingsSubscription.perMonth') || "per month"}
                  </Box>
                </Flex>
              ) : (
                ''
              )}
            </>
          )}
        </Box>
        {/* <ButtonContainer currentStep={checkoutStep} setSelectedCompany={props?.setSelectedCompany}/> */}
        {renderButtonContainer(checkoutStep)}
      </>
    );
  };

  return (
    <AuthenticatedProviders>
      {companyId && !selectedCompany ? (
        <Container maxW="1220px" border="1px solid #D9D9D9"
        borderRadius="8px"
        p={3}>
          <Card variant="thinBorderedCard" p={3} width="100%">
            <CardHeader p={0} borderBottom="1px solid #D9D9D9" pb={2} mb={2}>
              <Text fontSize="20px" fontWeight="400" color="black">
                {t('settingsSubscription.myJobSubscriptions') || "My Job subscriptions"}
              </Text>
            </CardHeader>
            <CardBody>
              {/* <MainSubscription /> */}
              {renderMainSubscription()}
            </CardBody>
          </Card>
        </Container>
      ) : (
        /* <MainSubscription /> */
        renderMainSubscription()
      )}

      <AlertDialog {...cardAlertDisc} isCentered>
        <AlertDialogOverlay />

        <AlertDialogContent>
          <AlertDialogHeader>{t('settingsSubscription.paymentMethod') || "Payment Method"}</AlertDialogHeader>
          <AlertDialogCloseButton />
          <AlertDialogBody>
            {t('settingsSubscription.noDefaultCard') || "You have not set any default card for payment, please add card for payment."}
          </AlertDialogBody>
          <AlertDialogFooter>
            <Button onClick={() => cardAlertDisc.onClose()}>{t('otherPage.no') || "No"}</Button>
            <Button
              variant="primary"
              ml={3}
              onClick={() => handlePaymentSettings()}
            >
              {t('settingsSubscription.setupCard') || "Setup Card"}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </AuthenticatedProviders>
  );
};

export default JobSubscriptionPage;
